<template>
  <div>
    <div v-if="isLoadData">
      <h2>请稍等 数据正在加载中 ......</h2>
    </div>
    <!-- 根据当前版本显示不同界面 -->
    <div ref="printBoxError" v-if="errorStatus === -99" >
      <ContentErrorV4 ref="content-error"  :data-map="dataMap" ></ContentErrorV4>
    </div>
    <div ref="printBoxUpload" v-else-if="errorStatus === 300" >
      <ContentUploadV4 ref="comUpload"  :data-map="dataMap" ></ContentUploadV4>
    </div>
    <div ref="printBox"  v-else-if="!isLoadData && !webVersion">
      <ContentAllV3 ref="contentAllV3" :home-stat="homeStat" :stat="stat" :bar-data="barData" :boardData="boardData"
                           :score="score" :data-map="dataMap"></ContentAllV3>
    </div>
    <div ref="printBox" v-else-if="!isLoadData && !isMobile() && webVersion === 4">
      <!-- 报告头信息 -->
      <ContentTitleV4 ref="contentTitle" :data-map="dataMap" :home-stat="homeStat" :score="score"></ContentTitleV4>
      <ContentBoardV4 ref="contentBoard" :data-map="dataMap" :home-stat="homeStat" :score="score" :boardData="boardData"></ContentBoardV4>
      <!-- <ContentDataReportV4 ref="contentDataReport" :home-sta="homeStat" :stat="stat" :bar-data="barData"
                         :score="score" :data-map="dataMap"></ContentDataReportV4> -->
      <ContentDetailV4 ref="content_detail"  :data-map="dataMap" :home-stat="homeStat" :score="score" :boardData="boardData" :stat="stat"></ContentDetailV4>
    </div>
    <div ref="printBoxV4Mb" v-else-if="!isLoadData && isMobile()  && webVersion === 4">
      <ContentMenuV4Mb ref="contentMenuV4Mb" :data-map="dataMap" :home-stat="homeStat" :score="score" :boardData="boardData" :stat="stat" :bar-data="barData"></ContentMenuV4Mb>
    </div>
  </div>
</template>

<script>
import ContentAllV3 from './content/content-all-v3.vue'
import ContentTitleV4 from './content-v4/content-title.vue'
import ContentBoardV4 from './content-v4/content-board.vue'
import ContentDetailV4 from './content-v4/content-detail.vue'
import ContentDataReportV4 from './content-v4/content-data-report.vue'
import ContentMenuV4Mb from './content-v4-mb/content-menu.vue'
import ContentErrorV4 from './content-v4/content-error.vue'
import ContentUploadV4 from './content-v4/content-upload.vue'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import 'print-js/dist/print.css'
export default {
  name: 'report-content',
  components: {
    html2canvas,
    printJS,
    ContentAllV3,
    ContentTitleV4,
    ContentBoardV4,
    ContentDetailV4,
    ContentDataReportV4,
    ContentMenuV4Mb,
    ContentErrorV4,
    ContentUploadV4
  },
  data () {
    return {
      errorStatus: 0,
      webVersion: 4,
      isLoadData: true,
      isShowDetail: false,
      isShowChartDetail: false,
      form: {},
      barData: {},
      isShow: false,
      type: 'add',
      disable: true,
      showRemoveFile: false,
      file: null,
      colSpan: 12,
      stat: this.getStatMap(),
      score: this.getScoreMap(),
      boardData: {},
      homeStat: {},
      dataMap: this.getDataMap(),
      headerColumns: [{
        title: '客户特征',
        key: 'name'
      }, {
        title: '特征值',
        key: 'data'
      }]
    }
  },
  methods: {
    setColSpan (span) {
      this.colSpan = span
    },
    showDetailInfo () {
      this.isShowDetail = true
    },
    showChartDetail () {
      this.isShowChartDetail = true
    },
    // 该方法用于判断是否进入手机端
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return !(flag === null)
    },
    getScoreMap () {
      return {
        consumptionCapacityScore: 0,
        creditRatingScore: 0
      }
    },
    getStatMap () {
      return {
        tradePieData: null,
        payoutPieData: null,
        incomingPieData: null,
        wordCloudData: null,
        consumeSubTypePieData: null,
        statInfo: {
          zhichu: null,
          shouru: null
        },
        progressData: 0,
        incomingList: {},
        payoutList: {},
        balanceList: {},
        headerData: []

      }
    },
    getDataMap () {
      return {
        monthlySummaryList: null,
        bank_balance_list: null
      }
    },
    clearData () {
      this.dataMap = this.getDataMap()
      this.stat = this.getStatMap()
      this.homeStat = {}
      this.score = this.getScoreMap()
      this.errorStatus = 0
    },
    loadData (id, token) {
      this.isLoadData = true
      this.isShowDetail = false
      this.isShowChartDetail = false
      this.clearData()
      let url = 'tradestat/report/' + id
      if (token) {
        url = url + '?token=' + token
      }
      this.G(url).then(data => {
        this.isLoadData = false
        this.dataMap = data
        this.webVersion = Number(data.webVersion)
        console.info(data.status)
        console.info(JSON.stringify(data))
        console.info(data.webVersion)
        if (data.status != null) {
          this.errorStatus = Number(data.status)
          return
        }
        // 总结数据
        let x = []
        let y = []
        for (let i = 0; i < data.pay_time_count_summary.length; i++) {
          x.push(data.pay_time_count_summary[i].statTime)
          y.push(data.pay_time_count_summary[i].countData)
        }
        this.barData = { x: x, y: y }
        this.stat.tradePieData = []
        for (let i = 0; i < data.hz_sj.length; i++) {
          this.stat.tradePieData.push({ value: data.hz_sj[i].money, name: data.hz_sj[i].businessType })
          if (data.hz_sj[i].businessType === '支出') {
            this.stat.statInfo.zhichu = data.hz_sj[i]
            this.stat.progressData = Number(data.hz_sj[i].rankData)
          }
          if (data.hz_sj[i].businessType === '收入') {
            this.stat.statInfo.shouru = data.hz_sj[i]
          }
        }
        this.homeStat = data.homeStat
        this.boardData = data.boardData
        this.stat.headerData = []
        this.stat.headerData.push({ name: '支出排名', data: this.stat.statInfo.zhichu.rankData + '%' })
        // this.stat.headerData.push({ name: '月均支出', data: this.stat.statInfo.zhichu.monthAvg })
        // this.stat.headerData.push({ name: '月均收入', data: this.stat.statInfo.shouru.monthAvg })
        this.stat.headerData.push({ name: '月均转入', data: this.dataMap.statMap.stat_transfer_month_income })
        this.stat.headerData.push({ name: '月均转出', data: this.dataMap.statMap.stat_transfer_month_payout })
        // 收入数据拼图
        this.stat.incomingList.x = data.line_stat_time
        this.stat.incomingList.y = []
        this.stat.incomingList.y.push({ name: '收单', data: data.incoming_acquiring_month_list })
        this.stat.incomingList.y.push({ name: '转账', data: data.incoming_transfer_month_list })
        this.stat.incomingList.y.push({ name: '红包', data: data.incoming_red_packet_month_list })
        this.stat.incomingList.y.push({ name: '工资', data: data.incoming_wages_month_list })
        this.stat.incomingPieData = []
        for (let i = 0; i < data.incoming_type_list.length; i++) {
          this.stat.incomingPieData.push({
            name: data.incoming_type_list[i].businessType,
            value: Number(data.incoming_type_list[i].money)
          })
        }
        // 支出数据拼团
        this.stat.payoutList.x = data.line_stat_time
        this.stat.payoutList.y = []
        this.stat.payoutList.y.push({ name: '消费', data: data.payout_consume_month_list })
        this.stat.payoutList.y.push({ name: '转账', data: data.payout_transfer_month_list })
        this.stat.payoutList.y.push({ name: '红包', data: data.payout_red_packet_month_list })
        this.stat.payoutList.y.push({ name: '还款', data: data.payout_repayment_month_list })
        // 余额走势图
        let flowTime = []
        let bankBalanceArr = []
        for (let i = 0; i < data.bank_balance_list.length; i++) {
          flowTime.push(data.bank_balance_list[i].flowTime)
          bankBalanceArr.push(Number(data.bank_balance_list[i].balance).toFixed())
        }
        this.stat.balanceList = { x: flowTime, y: [{ name: '银行卡', data: bankBalanceArr }] }
        this.stat.payoutPieData = []
        for (let i = 0; i < data.payout_type_list.length; i++) {
          this.stat.payoutPieData.push({
            name: data.payout_type_list[i].businessType,
            value: Number(data.payout_type_list[i].money)
          })
        }
        this.stat.payoutPieData = []
        for (let i = 0; i < data.payout_type_list.length; i++) {
          this.stat.payoutPieData.push({
            name: data.payout_type_list[i].businessType,
            value: Number(data.payout_type_list[i].money)
          })
        }
        this.stat.consumeSubTypePieData = []
        for (let i = 0; i < data.consume_sub_type.length; i++) {
          this.stat.consumeSubTypePieData.push({
            name: data.consume_sub_type[i].businessType,
            value: Number(data.consume_sub_type[i].money)
          })
        }
        // 词云 统计图
        this.stat.wordCloudData = []
        for (let i = 0; i < data.word_map.length; i++) {
          this.stat.wordCloudData.push({
            name: data.word_map[i].businessType,
            value: Number(data.word_map[i].countData)
          })
        }
        // 各种评分类数据赋值
        this.score.consumptionCapacityScore = data.homeStat.zhixi_score.capacityScore
        this.score.creditRatingScore = data.homeStat.zhixi_score.creditRating
      })
    },
    printIt () {
      html2canvas(this.$refs.printBox, {
        backgroundColor: 'white',
        dpi: 300,
        useCORS: true,
        foreignObjectRendering: false,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight
      }).then((canvas) => {
        const url = canvas.toDataURL()
        this.img = url
        printJS({
          printable: url,
          type: 'image',
          documentTitle: '--',
          style:
            '@media print{ @page { size: A4; margin: 0mm -1.5mm; mso-header: none; mso-footer: none;  } body{margin:0 20px;}}',
          base64: 'true'
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.count-style {
  font-size: 30px;
}
</style>
